import { render, staticRenderFns } from "./GifExercise.vue?vue&type=template&id=cfcf471c&scoped=true"
import script from "./GifExercise.vue?vue&type=script&lang=js"
export * from "./GifExercise.vue?vue&type=script&lang=js"
import style0 from "./GifExercise.vue?vue&type=style&index=0&id=cfcf471c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcf471c",
  null
  
)

export default component.exports